/**
 * @deprecated Please use DrawerModal instead of this component in favor of A11y.
 */
import React, { useEffect, useState } from "react";
import ClickOutsideDetector from "@streeteasy/design-system/legacy/ClickOutsideDetector";
import { bool, func } from "prop-types";

import KEYCODES from "src/shared/constants/key-codes";

import * as S from "./styled";

const Drawer = ({
  disableClickOutside,
  handleOnClose,
  isDarkOverlay,
  isLeftSide,
  isOpen,
  render,
  ...props
}) => {
  const [animate, setAnimate] = useState(false);

  const handleClose = () => {
    if (disableClickOutside) {
      return;
    }

    setAnimate(false);
    setTimeout(() => {
      handleOnClose();
    }, 500);
  };

  const handEscapeKeyPress = event => {
    if (event.keyCode === KEYCODES.ESCAPE) {
      handleClose();
    }
  };

  useEffect(() => {
    if (isOpen) {
      document.addEventListener("keydown", handEscapeKeyPress);
      document.querySelector("html").style.overflowY = "hidden";
      setAnimate(true);
    } else {
      document.removeEventListener("keydown", handEscapeKeyPress);
      document.querySelector("html").style.overflowY = "auto";
    }
  }, [isOpen]);

  return (
    isOpen && (
      <>
        <S.Overlay animate={animate} isDarkOverlay={isDarkOverlay} />
        <ClickOutsideDetector onClickOutside={handleClose}>
          <S.ContentWrapper animate={animate} isLeftSide={isLeftSide}>
            <S.ModalContent {...props}>{render(handleClose)}</S.ModalContent>
          </S.ContentWrapper>
        </ClickOutsideDetector>
      </>
    )
  );
};

Drawer.propTypes = {
  disableClickOutside: bool,
  handleOnClose: func.isRequired,
  isDarkOverlay: bool,
  isLeftSide: bool,
  isOpen: bool.isRequired,
  render: func.isRequired
};

Drawer.defaultProps = {
  disableClickOutside: false,
  isDarkOverlay: false,
  isLeftSide: false
};

export default Drawer;
